<template>
  <event-form>
    <ButtonUpdate class="mt_m"/>
    <ButtonDelete class="mt_s"/>
  </event-form>
</template>

<script>
import EventForm from '@/components/Event/Form'
import ButtonUpdate from '@/components/Event/ButtonUpdate'
import ButtonDelete from '@/components/Event/ButtonDelete'

export default {
  components: {
    EventForm,
    ButtonUpdate,
    ButtonDelete
  },

  created: async function () {
    await this.$store.dispatch(
      'event/getEvent',
      this.$route.params.id
    )
    this.$store.dispatch('event/initForm')
  }
}
</script>
